import React from 'react'
import FormInput from '../../../../../library/form/components/FormInput';
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormROValue from '../../../../../library/form/components/FormROValue1';

const ProdIOOExiCMNEditor = (props) => {
    const { formObject } = props;

    return (
        <>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "actualItem" }} value="Selected Item" />
                </span>
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "actualItem" }}/>
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyReturn1" }} value="Return Qty 1" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "qtyReturn1" }} className='uiSpacerH10'/>
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyReturn2" }} value="Return Qty 2" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey=""
                    action={{ InputType: "input", paramName: "qtyReturn2" }} className='uiSpacerH10'/>
            </li>
        </>
    )
}

export default ProdIOOExiCMNEditor;
